import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import Settings from "../../../constants/Settings";
import { SpecialPayment } from "@/model/SpecialPayment";
import { datePickerLang } from "@/constants/globalConstants";
import PayGroupService from "@/service/PayGroupService";
import ArrayHelper from "../../../common/helper/ArrayHelper";
import ImportFile from "@/components/FileReader";
import SpecialPaymentService from "../../../service/SpecialPaymentService";
import SweetAlertService from "../../../service/SweetAlertService";
import PayrollAdjustmentService from "../../../service/PayrollAdjustmentService";
import PayProfileService from "@/service/PayProfileService";
export default {
    components: {
        DatePicker,
        moment,
        ImportFile
    },
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
        disabledMode() {
            return this.selectMode == this.modelList.view
        },
        IncTypeList() {
            const list = this.incTypeList;
            const Datas = ArrayHelper.uniqueBykey(list, 'IncTypeDesc');
            return Datas
        },
        staffs() {
            let list = this.staffList;
            if (this.searchRec) {
                list = list.filter((x) => ArrayHelper.wildCardSearch(x, this.searchRec))
            }
            return list
        },
    },
    data() {
        return {
            menuRights: { allRights: {}, rightsForThisMenu: {} },
            menuId: Settings.MenuID.SpecialPayment,
            Settings: Settings,
            dictEnum: dictEnum,
            lang: datePickerLang,
            specPayList: [],
            specPayField: [
                {
                    key: "DateVal",
                    label: t.t(dictEnum.LBL_Date)
                },
                {
                    key: "PayDesc",
                    label: t.t(dictEnum.LBL_Particular)
                },
                {
                    key: "TotAmt",
                    label: t.t(dictEnum.LBL_Amount)
                },
                {
                    key: "Status",
                    label: t.t(dictEnum.LBL_Status)
                },
            ],
            currentPage: 1,
            perPage: 15,
            selectMode: "",
            paymentStatus: "All",
            paymentStatusList: [
                {
                    id: Settings.PayrollStatus.New,
                    value: t.t(dictEnum.LBL_New)
                },
                {
                    id: Settings.PayrollStatus.Approving,
                    value: t.t(dictEnum.LBL_Pending)
                },
                {
                    id: Settings.PayrollStatus.Approved,
                    value: t.t(dictEnum.LBL_Approved)
                },
                {
                    id: Settings.PayrollStatus.Released,
                    value: t.t(dictEnum.LBL_Released)
                },
                {
                    id: Settings.PayrollStatus.Closed,
                    value: t.t(dictEnum.LBL_Closed)
                },
                {
                    id: Settings.PayrollStatus.Rejected,
                    value: t.t(dictEnum.LBL_Rejected)
                }
            ],
            modelList: {
                edit: "Edit",
                view: "View"
            },
            selectedItem: {},
            specPaymentDetail: [],
            messageShow: false,
            messageList: [],
            selectedMsg: {},
            datePay: moment().format(Settings.DateTime.yyyymmdd),
            incTypeList: [],
            selectedIncType: {},
            selectedIncSubType: {},
            staffList: [],
            staffFields: [
                {
                    key: "StaffID",
                    label: t.t(dictEnum.LBL_ID),
                    thStyle: { width: "20%" }
                },
                {
                    key: "EName",
                    label: t.t(dictEnum.LBL_EngName),
                    thStyle: { width: "25%" }
                },
                {
                    key: "CName",
                    label: t.t(dictEnum.LBL_ChiName),
                    thStyle: { width: "25%" }
                },
                {
                    key: "Dept",
                    label: t.t(dictEnum.LBL_Department),
                    thStyle: { width: "20%" }
                },
            ],
            selectedStaffs: [],
            searchRec: "",
            currentPageStaff: 1,
            perPageStaff: 15,
        };

    },

    mounted() {
        this.assignRights();
        this.getPaymentList();
        this.getIncTypeList();
        this.getStaffList()
    },

    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];

            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },

        formatAmt(e) {
            return String(e).substring(0, 10);
        },

        StatusName(statusId) {
            const status = this.paymentStatusList.find((x) => x.id == statusId);
            if (status) {
                return status.value
            }
        },

        TotalActual() {
            let num = 0;
            if (this.specPaymentDetail.length > 0) {
                this.specPaymentDetail.forEach((x) => {
                    num = num + this.Actual(x)
                })
            }
            return num
        },

        Actual(item) {
            let num = 0;
            item.Details.forEach((x) => {
                num = num + Number(x.Total)
            })
            return num
        },

        initData() {
            this.selectMode = this.modelList.view;
            this.selectedItem = {};
            this.specPaymentDetail = [];
        },

        changeIncType() {
            this.selectedIncSubType = ''
        },

        async getStaffList() {
            var obj = {
                Company: '',
                Dept: '',
                PayGroup: '',
                PayType: ""
            };
            const response = await PayProfileService.getAllPayProfile(obj);
            if (response.data.IsSuccess) {
                this.staffList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getPaymentList() {
            const obj = {
                status: this.paymentStatus
            }
            const response = await SpecialPaymentService.getSpecialPaymentList(obj);
            if (response.data.IsSuccess) {
                ArrayHelper.sortByKey(response.data.Data, 'DateVal', false);
                this.specPayList = response.data.Data;
                this.initData();
            } else {
                SweetAlertService.warning("Warn", response.data.Message)
            }
        },

        async getIncTypeList() {
            const obj = {};
            const response = await PayrollAdjustmentService.getIncTypeList(obj);
            if (response) {
                this.incTypeList = response.data.Data.filter((x) => x.MPF)
            } else {
                SweetAlertService.warning("Warn", response.data.Message)
            }
        },

        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.TxNum == this.selectedItem.TxNum && item.Status == this.selectedItem.Status) {
                return 'selected-tr'
            }
        },

        cancelEditMode() {
            this.selectMode = this.modelList.view;
        },

        showAddSpecPayment() {
            this.$bvModal.show('SpecPaymentShow');
        },

        async addSpecialPayment() {
            if (!this.selectedIncType) {
                SweetAlertService.warning("Warn", `${t.t(dictEnum.LBL_IncType)} ${t.t(dictEnum.WARN_IsRequired)}`);
                return;
            }
            if (!this.selectedIncSubType) {
                SweetAlertService.warning("Warn", `${t.t(dictEnum.LBL_IncSubType)} ${t.t(dictEnum.WARN_IsRequired)}`);
                return;
            }
            this.selectedItem = {
                TxNum: "",
                CompCode: this.$store.getters[StoreGetter.serverRouter].CompCode,
                FiscalPer: moment(this.datePay).format("YYYY"),
                DateVal: moment(this.datePay).format(Settings.DateTime.yyyymmdd),
                IncTypeCode: this.selectedIncType,
                PayDesc: this.selectedItem.PayDesc,
                IncSubType: this.selectedIncSubType,
                Status: Settings.PayrollStatus.New,
                TotAmt: this.TotalActual(),
                DateAprv: "1900-01-01",
                AprvBy: "",
                AprvByName: null,
                AddByName: null,
                ModifyByName: null,
                AddBy: "admin",
                DateAdd: moment().format(Settings.DateTime.yyyymmdd),
                DateModify: "1900-01-01",
                ModifyBy: "admin",
                RecDel: false
            };
            this.selectMode = this.modelList.edit;
            this.specPaymentDetail = []
        },

        editSpecialPayment() {
            if (this.selectedItem.Status != Settings.PayrollStatus.New) return;
            this.selectMode = this.modelList.edit
        },

        async deleteSpecialPayment() {
            const sweetAlertOptions = {
                title: this.t.t(dictEnum.WARN_Confirm),
                text: `${t.t(dictEnum.WARN_Delete)}`,
                cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
                confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
            };
            const result = await SweetAlertService.question(sweetAlertOptions);
            if (result.value) {
                const obj = {
                    txNum: this.selectedItem.TxNum,
                    Status: this.selectedItem.Status
                }
                const response = await SpecialPaymentService.deleteSpecialPayment(obj);
                if (response.data.IsSuccess) {
                    SweetAlertService.success("Success", response.daat.Message)
                    this.getPaymentList();
                } else {
                    SweetAlertService.warning("Warn", response.data.Message)
                }
            }
        },

        clickStaffModal() {
            this.selectedStaffs = [];
            this.$bvModal.show("StaffTable")
        },

        rowClassStaff(item, type) {
            let list = [];
            this.specPaymentDetail.forEach((x) => {
                list = list.concat(x.Details)
            });
            list.forEach((x) => x.StaffID = x.Id);
            if (!item || type !== 'row') return
            const find = this.selectedStaffs.find((x) => x.StaffID == item.StaffID);
            if (find) return 'selected-tr'
            const value = list.find((x) => x.StaffID == item.StaffID);
            if (value) return 'selected-tr'
        },

        OnStaffSelect(item) {
            const stf = this.selectedStaffs.find((x) => x.StaffID == item.StaffID);
            if (stf) {
                this.selectedStaffs = this.selectedStaffs.filter((x) => x.StaffID != item.StaffID);
            } else {
                this.selectedStaffs.push(item);
            }
        },

        AddPaymentDtl() {
            let failStaff = []
            for (const item of this.selectedStaffs) {
                const deptFind = this.specPaymentDetail.find((x) => x.Dept == item.Dept);
                if (deptFind) {
                    const staffFind = deptFind.Details.find((s) => s.Id == item.StaffID);
                    if (staffFind) failStaff.push(staffFind)
                    if (!staffFind) {
                        deptFind.Details.push({
                            Id: item.StaffID,
                            Name: this.user.Lang == 'EN' ? item.EName : item.CName,
                            Type: item.PayTypeCode,
                            Dept: item.Dept,
                            Total: 0,
                            DateJoin: item.JoinDate,
                        })
                    }
                } else {
                    const obj = {
                        Dept: item.Dept,
                        CopeWith: 0,
                        ActualPayment: 0,
                        Details: [
                            {
                                Id: item.StaffID,
                                Name: this.user.Lang == 'EN' ? item.EName : item.CName,
                                DateJoin: item.JoinDate,
                                Type: item.PayTypeCode,
                                Dept: item.Dept,
                                Total: 0,
                                Status: Settings.PayrollStatus.New
                            }
                        ]
                    }
                    this.specPaymentDetail.push(obj)
                }
            }
            if (failStaff.length > 0) {
                const staffs = failStaff.map((x) => x.Id).toString()
                SweetAlertService.warning("Warn", staffs + ' ' + t.t(dictEnum.MSG_AlreadyExists))
            }
            this.$bvModal.hide('StaffTable');
        },

        deleteStaffDetail(staffID, Dept) {
            const deptFind = this.specPaymentDetail.find((x) => x.Dept == Dept);
            if (deptFind) {
                deptFind.Details = deptFind.Details.filter((s) => s.Id != staffID);;
                if (deptFind.Details.length == 0) {
                    this.specPaymentDetail = this.specPaymentDetail.filter((x) => x.Dept != Dept)
                }
            }
        },

        async clickExport() {
            // const obj = {
            //     txNum: this.selectedItem.TxNum
            // }
            // const response = await SpecialPaymentService.exportSpecialPayment(obj);
            // if (response.data.IsSuccess) {
            //     SweetAlertService.success("Success", response.data.Message)
            // } else {
            //     SweetAlertService.warning("Warn", response.data.Message)
            // }

            this.ExportTableData()
        },

        async ExportTableData() {
            const sweetAlertOptions = {
                title: this.t.t(dictEnum.WARN_Confirm),
                text: this.t.t(dictEnum.MSG_ExportFile),
                cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
                confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
            };
            const result = await SweetAlertService.question(sweetAlertOptions);
            if (result.value) {
                let list = [], data = [];
                for (const i in this.specPaymentDetail) {
                    const data = this.specPaymentDetail[i];
                    list = list.concat(data.Details)
                }
                list.forEach(x => {
                    data.push({
                        StaffID: x.Id,
                        StaffName: x.Name,
                        DateJoin: moment(x.DateJoin).format(Settings.DateTime.yyyymmdd),
                        DateTx: moment(this.selectedItem.DateTx).format(
                            Settings.DateTime.yyyymmdd
                        ),
                        Type: x.Type,
                        Dept: x.Dept,
                        Particular: this.selectedItem.Particular,
                        IncType: this.selectedItem.IncTypeCode,
                        IncSubType: this.selectedItem.IncSubType,
                        Total: x.Total
                    });
                });
                var XLSX = require("xlsx");
                var worksheet = XLSX.utils.json_to_sheet(data, false);
                let workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet);
                XLSX.writeFile(
                    workbook,
                    'SpecialPayment' + "_" + moment().format(Settings.DateTime.yyyymmddhhmmss) + ".xlsx"
                );
            }
        },

        async clickPrint() {
            const obj = {
                txNum: this.selectedItem.TxNum,
            }
            const response = await SpecialPaymentService.printSpecialPayment(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message)
            } else {
                SweetAlertService.warning("Warn", response.data.Message)
            }
        },

        async clickSendSpecPayment() {
            const sweetAlertOptions = {
                title: this.t.t(dictEnum.WARN_Confirm),
                text: this.t.t(dictEnum.BTN_Submit),
                cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
                confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
            };
            const result = await SweetAlertService.question(sweetAlertOptions);
            if (result.value) {
                const obj = {
                    txNum: this.selectedItem.TxNum,
                    status: this.selectedItem.Status
                };
                const response = await SpecialPaymentService.sendSpecialPayment(obj);
                if (response.data.IsSuccess) {
                    SweetAlertService.success("Success", response.data.Message)
                    this.getPaymentList();
                } else {
                    SweetAlertService.warning("Warn", response.data.Message);
                }
            }
        },

        async OnSpecialPaymentSelect(item) {
            item.DateVal = moment(item.DateVal).format(Settings.DateTime.yyyymmdd)
            this.selectedItem = JSON.parse(JSON.stringify(item));
            const obj = {
                txNum: item.TxNum,
                status: item.Status
            }
            const response = await SpecialPaymentService.getSpecialPaymentDtl(obj);
            if (response.data.IsSuccess) {
                this.specPaymentDetail = response.data.Data;
                this.selectMode = this.modelList.view;
                this.getPaymentMessage()
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async clickSaveDtl() {
            let list = [], datas = [], header = this.selectedItem;
            header.PayDesc = header.Particular ? header.Particular : header.IncSubType;
            this.specPaymentDetail.forEach((x) => {
                return list = list.concat(x.Details)
            })

            list.forEach((x) => {
                datas.push({
                    TxNum: header.TxNum,
                    CompCode: header.CompCode,
                    FiscalPer: header.FiscalPer,
                    StaffID: x.Id,
                    DateVal: moment(this.selectedItem.DateVal).format(Settings.DateTime.yyyymmdd),
                    Amt: x.Total,
                    Status: x.Status,
                    DateAdd: moment().format(Settings.DateTime.yyyymmdd),
                    DateModify: moment().format(Settings.DateTime.yyyymmdd),
                    AddBy: this.user.UserID,
                    ModifyBy: this.user.UserID,
                    RecDel: false,
                })
            })
            const obj = {
                specPay: { hdr: header, dtls: datas }
            }
            const response = await SpecialPaymentService.saveSpecialPayment(obj);
            if (response.data.IsSuccess) {
                this.getPaymentList();
                SweetAlertService.success("Success", response.data.Message)
            } else {
                SweetAlertService.warning("Warn", response.data.Message)
            }
        },

        importData(value) {
            var XLSX = require("xlsx");
            const input = $("#fileReader");
            let reader = new FileReader();
            reader.readAsBinaryString(input[0].files[0]);
            reader.onload = async e => {
                let workbook = XLSX.read(e.target.result, { type: "binary", });
                let sheetList = workbook.SheetNames;
                let rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetList[0]], { defval: "" })
                rows = rows.map((obj) => Object.values(obj));
                let list = []
                for (let row of rows) {
                    const data = {
                        StaffID: row[0],
                        DatePay: moment(row[3]).format(Settings.DateTime.yyyymmdd),
                        Particular: row[6],
                        IncTypeCode: row[7],
                        IncSubType: row[8],
                        Amount: row[9],
                    }
                    list.push(data)
                }
                const obj = {
                    model: list
                }
                const response = await SpecialPaymentService.importSpecialPayment(obj);
                if (response.data.IsSuccess) {
                    this.getPaymentList();
                    SweetAlertService.success("Success", response.data.Message)
                } else {
                    SweetAlertService.warning("Warn", response.data.Message);
                }
            }

        },

        async getPaymentMessage() {
            const obj = {
                txNum: this.selectedItem.TxNum
            }
            const response = await SpecialPaymentService.getSpecialPaymentMsg(obj);
            if (response.data.IsSuccess) {
                this.messageList = response.data.Data;
                this.selectedMsg = {}
                ArrayHelper.sortByKey(this.messageList, 'DateAdd', false)
            } else {
                SweetAlertService.warning("Warn", response.data.Message)
            }
        },

        async showPaymentMessage() {
            this.$bvModal.show("messageShow")
            this.selectedMsg = this.messageList[0];
        },

        clickMsg(item) {
            this.selectedMsg = item
        }
    },
};


// WEBPACK FOOTER //
// ./src/components/100000-Payroll/102000-SpecialPayment/102000-SpecialPayment.js